import PropTypes from "prop-types"
import { Redirect, Switch } from "react-router-dom"
import Route from "~/components/Route"
import NotFound from "~/pages/NotFound"
import Vaas from "~/v2/pages/vaas"
import VaasCreate from "~/v2/pages/vaas/pages/create"
import VaasList from "~/v2/pages/vaas/pages/list"
import VaasCourse from "~/v2/pages/vaas/pages/vaas-course"

// const PageComponents = {}
// const componentsReq = require.context("./pages", true, /^(.*\.(jsx$))[^.]*$/im)
// componentsReq
//   .keys()
//   .filter((x) => x.indexOf("index.jsx") > -1)
//   .forEach((x) => {
//     // https://regexr.com/54uqs - selects ./ and /pages/ from file locations
//     // https://regexr.com/54uqv - selects index.jsx files
//     const componentName = x
//       .replace(/\/(\w|:|-)+\.jsx$/g, "")
//       .replace(/(\/pages\/|\.\/)/g, "")
//     PageComponents[componentName] = componentsReq(x).default
//   })

const PageComponents = {}
const componentsReq = import.meta.glob("./pages/**/index.jsx", { eager: true })
Object.keys(componentsReq)
  .filter((x) => x.indexOf("index.jsx") > -1)
  .forEach((x) => {
    const componentName = x
      .replace("/pages", "")
      .replace(/\/(\w|:|-)+\.jsx$/g, "")
      .replace(/(\/pages\/|\.\/)/g, "")
    PageComponents[componentName] = componentsReq[x].default
  })
Object.keys(componentsReq)
  .filter((x) => x.indexOf("index.jsx") > -1)
  .forEach((x) => {
    // https://regexr.com/54uqs - selects ./ and /pages/ from file locations
    // https://regexr.com/54uqv - selects index.jsx files
    const componentName = x
      .replace("/pages", "")
      .replace(/\/(\w|:|-)+\.jsx$/g, "")
      .replace(/(\/pages\/|\.\/)/g, "")
    // PageComponents[componentName] = componentsReq(x).default

    PageComponents[componentName] = componentsReq[x].default
  })

PageComponents.Vaas = Vaas
PageComponents.VaasList = VaasList
PageComponents.VaasCreate = VaasCreate
PageComponents.VaasCourse = VaasCourse

export const routeConfig = [
  {
    path: "/",
    exact: true,
    component: "Login",
  },
  {
    path: "/login",
    component: "Login",
    protected: false,
  },
  {
    path: "/certifications",
    component: "Certifications",
    protected: true,
    routes: [
      {
        path: "/certifications",
        component: "CertificationsList",
        protected: true,
        exact: true,
      },
      {
        path: "/certifications/:certification_id",
        component: "CertificationsCertification",
        protected: true,
        routes: [
          {
            path: "/certifications/:certification_id/content",
            component: "CertificationsCertificationContent",
            protected: true,
            exact: true,
          },
          {
            path: "/certifications/:certification_id/seo",
            component: "CertificationsCertificationSeo",
            protected: true,
            exact: true,
          },
          {
            path: "/certifications/:certification_id/analytics",
            component: "CertificationsCertificationAnalytics",
            protected: true,
          },
        ],
      },
    ],
  },
  {
    path: "/learning-paths",
    component: "Paths",
    protected: true,
    routes: [
      {
        path: "/learning-paths",
        component: "PathsList",
        protected: true,
        exact: true,
      },
      {
        path: "/learning-paths/:learningPath_id",
        component: "PathsPath",
        protected: true,
        routes: [
          {
            path: "/learning-paths/:learningPath_id/content",
            component: "PathsPathContent",
            protected: true,
            exact: true,
          },
          {
            path: "/learning-paths/:learningPath_id/seo",
            component: "PathsPathSeo",
            protected: true,
            exact: true,
          },
          {
            path: "/learning-paths/:learningPath_id/analytics",
            component: "PathsPathAnalytics",
            protected: true,
          },
        ],
      },
    ],
  },

  {
    path: "/vaas",
    component: "Vaas",
    protected: true,
    routes: [
      {
        path: "/vaas",
        component: "VaasList",
        protected: true,
        exact: true,
      },
      {
        path: "/vaas/create",
        component: "VaasCreate",
        protected: true,
        exact: true,
      },
      {
        path: "/vaas/:course_id",
        component: "VaasCourse",
        protected: true,
        exact: true,
      },
    ],
  },
  {
    path: "/courses",
    component: "Courses",
    protected: true,
    routes: [
      {
        path: "/courses",
        component: "CoursesList",
        protected: true,
        exact: true,
      },
      {
        path: "/courses/:course_id",
        component: "CoursesCourse",
        protected: true,
        routes: [
          {
            path: "/courses/:course_id",
            component: "CoursesCourseContent",
            protected: true,
            exact: true,
          },
          {
            path: "/courses/:course_id/seo",
            component: "CoursesCourseSeo",
            protected: true,
          },
          {
            path: "/courses/:course_id/analytics",
            component: "CoursesCourseAnalytics",
            protected: true,
          },
          {
            path: "/courses/:course_id/resources",
            component: "CoursesCourseResources",
            protected: true,
          },
          {
            path: "/courses/:course_id/settings",
            component: "CoursesCourseSettings",
            protected: true,
          },
          {
            path: "/courses/:course_id/testUsers",
            component: "CoursesCourseTestUsers",
            protected: true,
          },
          {
            path: "/courses/:course_id/translations",
            component: "CoursesCourseTranslations",
            protected: true,
          },
        ],
      },
    ],
  },
  {
    path: "/lessons",
    component: "Lessons",
    protected: true,
    routes: [
      {
        path: "/lessons",
        component: "LessonsList",
        protected: true,
        exact: true,
      },
      {
        path: "/lessons/:lesson_id",
        component: "LessonsLesson",
        protected: true,
        routes: [
          {
            path: "/lessons/:lesson_id",
            component: "LessonsLessonContent",
            protected: true,
            exact: true,
          },
          {
            path: "/lessons/:lesson_id/cues",
            component: "LessonsLessonCues",
            protected: true,
          },
          {
            path: "/lessons/:lesson_id/resources",
            component: "LessonsLessonResources",
            protected: true,
          },
          {
            path: "/lessons/:lesson_id/analytics",
            component: "LessonsLessonAnalytics",
            protected: true,
          },
          {
            path: "/lessons/:lesson_id/settings",
            component: "LessonsLessonSettings",
            protected: true,
          },
        ],
      },
    ],
  },
  {
    path: "/labs",
    component: "Labs",
    protected: true,
    routes: [
      {
        path: "/labs",
        component: "LabsList",
        protected: true,
        exact: true,
      },
      {
        path: "/labs/:lab_id",
        component: "LabsLab",
        protected: true,
      },
    ],
  },
  {
    path: "/categories",
    component: "Categories",
    protected: true,
    routes: [
      {
        path: "/categories",
        component: "CategoriesList",
        protected: true,
        exact: true,
      },
      {
        path: "/categories/:category_id",
        component: "CategoriesCategory",
        protected: true,
        exact: true,
      },
      {
        path: "/categories/:category_id/seo",
        component: "CategoriesSeo",
        protected: true,
        exact: true,
      },
      {
        path: "/categories/:category_id/channels",
        component: "CategoriesChannels",
        protected: true,
        exact: true,
      },
    ],
  },
  {
    path: "/users",
    component: "Users",
    protected: true,
    routes: [
      {
        path: "/users/user-list",
        component: "UsersUser",
        protected: true,
      },
      {
        path: "/users/admin-list",
        component: "UsersAdmin",
        protected: true,
      },
      // {
      //   "path": "/users/waitlist",
      //   "component": "UsersWaitlist",
      //   "protected": true
      // }
      {
        path: "/users/analytics",
        component: "UsersAnalytics",
        protected: true,
      },
      {
        path: "/users/demo",
        component: "UsersDemo",
        protected: true,
      },
    ],
  },
  {
    path: "/clients",
    component: "Clients",
    protected: true,
    routes: [
      {
        path: "/clients",
        component: "ClientsList",
        protected: true,
        exact: true,
      },
      {
        path: "/clients/:client_id",
        component: "ClientsClient",
        protected: true,
        routes: [
          {
            path: "/clients/:client_id",
            component: "ClientsClientDetails",
            protected: true,
            exact: true,
          },
          {
            path: "/clients/:client_id/dashboard",
            component: "ClientsClientDashboard",
            protected: true,
            exact: true,
          },
        ],
      },
    ],
  },
  {
    path: "/instructors",
    component: "Instructors",
    protected: true,
  },
  {
    path: "/subscriptions",
    component: "Subscriptions",
    protected: true,
  },
  {
    path: "/discounts",
    component: "Discounts",
    protected: true,
  },
  {
    path: "/documents",
    component: "Documents",
    protected: true,
    routes:[
      {
        path: "/documents",
        component: "DocumentsList",
        protected: true,
        exact: true
      },
      {
        path: "/documents/:doc_id",
        component: "DocumentsDoc",
        protected: true,
        routes: [
          {
            path: "/documents/:doc_id/details",
            component: "DocumentsDocDetails",
            protected: true,
            exact: true
          },
          {
            path: "/documents/:doc_id/translations",
            component: "DocumentsDocTranslations",
            protected: true,
            exact: true
          },
        ]
      }
    ]
  },
]

export const Router = ({ routes, match }) => {
  let path = ""
  if (match) {
    path = match.path
  }
  return (
    <Switch>
      <Redirect from="/:url*(/+)" to={window.location.pathname.slice(0, -1)} />
      {routes.map(({ component, ...rest }, i) => (
        <Route key={i} {...rest} component={PageComponents[component]} />
      ))}
      <Route path={`${path}/*`} component={NotFound} />
    </Switch>
  )
}

Router.propTypes = {
  routes: PropTypes.array,
  match: PropTypes.object,
}

export default Router
